import React from 'react';
import Layout from '../Layout';
import { Route } from 'react-router-dom';

export default function PublicRoute({ component, ...rest }) {
    const renderFunc = (Component) => (props) => <Layout showBreadcrumb={false}><Component {...props} /></Layout>;

    return <Route {...rest} render={renderFunc(component)} />;
}